import React, { Component } from 'react';
import $ from 'jquery';
import * as Common from '../../../static/js/Common';
import { DataPicker1 } from '../../picker/DataPicker1';

class DaySelectBoxV2 extends Component {
  async componentDidMount() {
    function selectOut() {
      document.querySelector('body').addEventListener('click', function(e) {
        if(e.target.className !== 'daySelectText selectText') {
          $(`.daySelect.select`).removeClass('active')
        }
      })
    }

    selectOut()
  }

  constructor(props) {
    super(props)

    this.state = {
      startDate: props.startDate,
      endDate: props.endDate,
      dayType: props.dayType
    }
  }

  daySelectText = () => {
    $('.daySelect').addClass('active')
  }

  dayOption = (e) => {
    let dataset = e.currentTarget.dataset;
    let dataId = dataset.id;
    let dataName = dataset.name

    let startDay;
    let endDay;
    let today = new Date();

    $('.daySelectText').text(dataName)
    $('.daySelectText').attr('data-type', dataId)

    if(dataId === '1') {
      endDay = new Date(today.setDate(today.getDate() + 1));
      startDay = new Date(today.setDate(today.getDate() - 1));;
    } else if(dataId === '2') {
      endDay = new Date(today.setDate(today.getDate() + 1));
      startDay = new Date(today.setDate(today.getDate() - 7));
      
    } else if(dataId === '3') {
      endDay = new Date(today.setDate(today.getDate() + 1));
      startDay = new Date(today.setDate(today.getDate() - 30));
    }

    if(dataId !== '4') {
      let startDay1 = Common.dayChange(startDay);
      let endDay1 = Common.dayChange(endDay);

      this.setState({ startDate: startDay1, endDate: endDay1 })
    }
  }

  render() {
    let state = this.state

    let dayText = "조회 당일";
    if(state.dayType === 2) {
      dayText = "최근 1주일 이내";
    } else if(state.dayType === 3) {
      dayText = "최근 30일 이내";
    } else if(state.dayType === 4) {
      dayText = "기간 직접 입력";
    }

    return (
      <div className='selectBox'>
        <div className='daySelect select width160'>
          <div id="daySelectText" className='daySelectText selectText' onClick={ this.daySelectText } data-type={state.dayType}>
            {dayText}
          </div>
          <ul className='daySelectOptionList selectOptionList'>
            <li className='selectoption' data-id='1' data-name='조회 당일' onClick={ this.dayOption }>조회 당일</li>
            <li className='selectoption' data-id='2' data-name='최근 1주일 이내' onClick={ this.dayOption }>최근 1주일 이내</li>
            <li className='selectoption' data-id='3' data-name='최근 30일 이내' onClick={ this.dayOption }>최근 30일 이내</li>
            <li className='selectoption' data-id='4' data-name='기간 직접 입력' onClick={ this.dayOption }>기간 직접 입력</li>
          </ul>
        </div>
        
        <DataPicker1 id='startDate' day={ new Date(state.startDate) } />
        <DataPicker1 id='endDate' day={ new Date(state.endDate) } />
      </div>
    )
  }
}

export { DaySelectBoxV2 }